import * as React from 'react';

import WorkflowStep from '../../WorkflowStep';
import DisclaimerForm from './DisclaimerForm';
import Fieldset from '../../../components/forms/Fieldset';
import { Button } from '../../../components/buttons';
import { IconChevronLeft, IconChevronRight } from '../../../components/icons';
import { Validation, InputError } from '../../../common/utils';
import { Spinner } from '../../../components/common';
import userAPI from '../../../user/userAPI';

interface Props {
	user: UserDetails;
	customerDetails: CustomerDemographicDetails;
	questionnaire: any;
	actions: any;
	history: any;
	match: any;
	className?: string;
	onUserChange?: (e: any) => void;
	errors: any;
}
class DisclaimerPage extends React.Component<Props, any> {

	errors = { email: {} as InputError };
	
	public constructor(props: Props) {
		super(props);
		this.state = { isSaving: false };
	}

	isNextDisabled = () => {
		if (!this.props.questionnaire.declareTrue
			|| !this.props.user.firstName
			|| !this.props.user.lastName
			|| !this.props.user.email
			|| !this.props.user.phoneNumber
			|| this.state.isSaving
		) {
			return true;
		}

		return this.errors.email.hasError;
	}

	validate = () => {
		// true means invalid
		return {
			email: Validation.validateEmail(this.props.user.email),
		};
	}

	save = () => {
		// call API directly here since we need the response from axios but not from store
		return userAPI.updateUserWithEmailChecker(this.props.user)
			.then((returnedUser: UserDetails) => {
				if (returnedUser.id === this.props.user.id) {
					const customerDetails: CustomerDemographicDetails = {
						...this.props.customerDetails,
						customerId: this.props.user.id
					};
					this.props.actions.saveCustomerDetails(customerDetails);
					return false;
				} else {
					this.props.history.push(`/existing-account-found`);
					return true;
				}
			});
	}

	back = () => {
		this.props.history.push(`/quote/${this.props.match.params.workflow}/select-your-policy`);
	}

	next = () => {
		this.setState({isSaving: true });
		this.save()
		.then((redirected: boolean) => {
			if (!redirected) {
				this.setState({ isSaving: false });
				this.props.history.push(`/quote/${this.props.match.params.workflow}/enrollment/basics`);
			}
		});
	}

	render() {
		this.errors = this.validate();
		const { className, ...props } = this.props;
		return (
			<WorkflowStep className={className} title="Let's be honest.">
				<Fieldset>
					<DisclaimerForm {...props} errors={this.errors} />
				</Fieldset>
				<div className="workflow-progress-actions">
					<Button onClick={this.back} className="btn-outline-primary workflow-progress-action">
						<IconChevronLeft />
						<span className="align-middle mx-2 d-none d-sm-inline-block">Back</span>
					</Button>
					<Button
						id="nextBtnBasics"
						onClick={this.next}
						className="btn-primary workflow-progress-action"
						disabled={this.isNextDisabled()}
					>
						<span className="align-middle mx-2">Next</span>
						{!this.state.isSaving && <IconChevronRight />}
						{this.state.isSaving && <Spinner />}
					</Button>
				</div>
			</WorkflowStep>
		);
	}
}

export default DisclaimerPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/DisclaimerPage.tsx